"use client";

import { BarChart3Icon, ActivityIcon } from "lucide-react";
import { useAdherenceFlags } from "@/hooks/use-adherence-monitor";
import { Badge } from "@/components/ui/badge";

import {
  SidebarGroup,
  SidebarGroupContent,
  SidebarGroupLabel,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
} from "@/components/ui/sidebar";

export function NavAnalytics({
  onNavigate,
  activePage,
}: {
  onNavigate: (page: string) => void;
  activePage: string;
}) {
  const { flags } = useAdherenceFlags();
  const unacknowledgedCount = flags.filter((f) => !f.acknowledged).length;

  const analyticsItems = [
    {
      name: "Operations Dashboard",
      id: "operations-dashboard",
      url: "#",
      icon: BarChart3Icon,
      visualName: "Operations",
      badge: unacknowledgedCount > 0 ? unacknowledgedCount : null,
    },
  ];

  return (
    <SidebarGroup>
      <SidebarGroupLabel>Analytics</SidebarGroupLabel>
      <SidebarGroupContent className="py-0.5">
        <SidebarMenu>
          {analyticsItems.map((item) => (
            <SidebarMenuItem key={item.name}>
              <SidebarMenuButton
                asChild
                isActive={activePage === item.id}
                onClick={() => onNavigate(item.id)}
              >
                <a
                  href={item.url}
                  onClick={(e) => e.preventDefault()}
                  className="flex items-center justify-between w-full"
                >
                  <span className="flex items-center gap-2">
                    <item.icon className="h-4 w-4" />
                    <span>{item.name}</span>
                  </span>
                  {item.badge && (
                    <Badge
                      variant="destructive"
                      className="h-5 min-w-[20px] rounded-full px-1.5 text-xs"
                    >
                      {item.badge}
                    </Badge>
                  )}
                </a>
              </SidebarMenuButton>
            </SidebarMenuItem>
          ))}
        </SidebarMenu>
      </SidebarGroupContent>
    </SidebarGroup>
  );
}
